import { createSelector } from 'reselect'

import { getCancelTicketIn24hsState } from './cancellationIn24hs'

const getStateClaimReservationAndService = state => state.claimsReservationAndService
const getStateCacClaims = state => state.cacClaims
const getStateEquipamentClaim = state => state.equipamentClaim

export const formSuccess = createSelector(
  [
    getStateClaimReservationAndService,
    getStateCacClaims,
    getStateEquipamentClaim,
    getCancelTicketIn24hsState
  ],
  (stateReservationAndService, stateCacClaims, stateEquipamentClaim, stateCancellationIn24hs) => {
    return (
      stateReservationAndService?.data ||
      stateCacClaims?.data ||
      stateEquipamentClaim?.data ||
      stateCancellationIn24hs?.data ||
      null
    )
  }
)
